import { Sim } from '../model';

export class SimMapper {
  public static map(data: any): Sim {
    return data
      ? new Sim(data.mcc, data.mnc, data.iccId, data.carrierName, data.phoneNumber)
      : null;
  }
}
